import React, { useState, useEffect } from 'react';
import api from '../../../services/api';
import { buildMediaUrl } from '../../../utils/mediaUrl';

const ClientsPreview = ({ isAdminPreview = true }) => {
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchData = async () => {
    try {
      const res = await api.get('/business/clients/');
      setClients(res.data || []);
    } catch (err) {
      console.error('Error fetching clients:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
    if (isAdminPreview) {
      const interval = setInterval(fetchData, 2000);
      return () => clearInterval(interval);
    }
  }, [isAdminPreview]);

  if (loading) {
    return (
      <div style={{ padding: '2rem', textAlign: 'center' }}>
        <div style={{
          width: '2rem', height: '2rem',
          border: '3px solid rgba(255,255,255,0.1)',
          borderTopColor: '#6366f1',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite',
          margin: '0 auto'
        }} />
      </div>
    );
  }

  if (!clients.length) {
    return (
      <div style={{
        padding: '2rem',
        textAlign: 'center',
        color: 'rgba(255,255,255,0.5)',
        backgroundColor: '#1e293b',
        minHeight: '200px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        No clients added yet.
      </div>
    );
  }

  return (
    <div style={{ padding: '1.5rem', backgroundColor: '#1e293b', minHeight: '200px' }}>
      <h2 style={{ fontSize: '1.25rem', fontWeight: '700', color: '#fff', textAlign: 'center', marginBottom: '1.5rem' }}>
        Our Clients
      </h2>
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(4, 1fr)',
        gap: '1rem',
        alignItems: 'center'
      }}>
        {clients.slice(0, 8).map((client, index) => (
          <div
            key={client.id || index}
            style={{
              padding: '0.75rem',
              backgroundColor: 'rgba(255,255,255,0.05)',
              borderRadius: '0.5rem',
              textAlign: 'center'
            }}
          >
            {client.logo ? (
              <img
                src={buildMediaUrl(client.logo)}
                alt={client.name}
                style={{
                  maxWidth: '60px',
                  maxHeight: '30px',
                  objectFit: 'contain',
                  margin: '0 auto',
                  filter: 'brightness(0) invert(1)',
                  opacity: 0.8
                }}
              />
            ) : (
              <span style={{ color: '#fff', fontSize: '0.7rem', fontWeight: '500' }}>
                {client.name}
              </span>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ClientsPreview;
